import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//Google Tag Manager
import "@/util/googleTagManager.js"; // <For IE>從這裡注入才能被 babel cover 到

//vue-axios
import '@/util/axios.js';

//element-ui
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-TW';

Vue.use(Element, { locale });

//jQuery
import $ from 'jquery';
window.$ = $;

//vue-scrollTo
import ScrollTo from 'vue-scrollto';
Vue.use(ScrollTo);

//scss
import "@/assets/css/style.scss";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#content')
